import * as Sentry from "@sentry/nuxt";

// Get DSN from runtime config or environment variables
const getDsn = () => {
  // Try multiple sources for DSN
  try {
    const runtimeConfig = useRuntimeConfig?.();
    if (runtimeConfig?.public?.sentryDsn) {
      return runtimeConfig.public.sentryDsn;
    }
  } catch {
    console.warn("Runtime config not available, falling back to env vars");
  }

  return import.meta.env.NUXT_PUBLIC_SENTRY_DSN || process.env.SENTRY_DSN;
};

const dsn = getDsn();
console.log("Sentry DSN:", dsn ? "configured" : "missing");

Sentry.init({
  dsn,

  // Enable debug in development to see what's happening
  debug: true,

  // Higher sample rates for testing
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  // Keep replay integration
  integrations: [Sentry.replayIntegration()],

  // Capture more errors
  beforeSend(event) {
    console.log("Sentry event being sent:", event);
    return event;
  },
});

// Test if Sentry is working
console.log("Sentry initialized");
